export const JobVideoInterviewPrivateDays = 3
export const VideoInterviewWillBePublicText = `Link will be accessible after ${JobVideoInterviewPrivateDays} days from video interview submission.`;